import { ThemeIcon, ThemeIconProps } from "@mantine/core";

import SvgIconRaw, { IconName } from "~/components/SvgIconRaw";

export type { IconName };

export type ThemeSvgIconProps = Omit<ThemeIconProps, "children"> & {
  name: IconName;
};

const ThemeSvgIcon = ({ name, ...rest }: ThemeSvgIconProps) => (
  <ThemeIcon {...rest}>
    {/*
      The icons render at a fixed 24px, independent of the ThemeIcon box size —
      this preserves the pre-dedupe behavior, where the inner SVG rendered at its
      intrinsic 24-grid px (SvgIconRaw always sets an explicit width/height, so an
      explicit size is required to match the previous intrinsic rendering).
    */}
    <SvgIconRaw name={name} size={24} />
  </ThemeIcon>
);

export default ThemeSvgIcon;
